import React from "react";
import PublicPageLayout from "./PublicPageLayout";

const questions = [
  ["Tallarge 適合誰使用？", "適合需要管理工作、司機、車輛、貨物與配送紀錄的運輸與物流團隊。"],
  ["需要登入才能查看產品嗎？", "不需要。產品與服務介紹是公開內容；工作管理等內部功能才需要登入。"],
  ["可以追蹤配送狀態嗎？", "可以依照工作設定 QR Code、收件者追蹤與通知流程。"],
];

export default function FAQ() {
  return (
    <PublicPageLayout
      title="常見問題"
      intro="先從這裡找到 Tallarge 常見功能的簡單說明。"
    >
      <div className="public-page-list">
        {questions.map(([title, text]) => (
          <article className="public-page-row" key={title}>
            <h2>{title}</h2>
            <p>{text}</p>
          </article>
        ))}
      </div>
    </PublicPageLayout>
  );
}
